import styled from '@emotion/styled';
import { getNavigationUrl, useResponsiveUrl } from '../../../utils';
import { Banner, CardImage, Link, Text } from 'common/styles';
import { Widget } from '../../../apiService';

const PosterOverlay = styled.div(({ theme }) => ({
  position: 'absolute',
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 1,
  padding: theme.spacing(2),
  background: 'linear-gradient(to top, rgba(0,0,0,0.75), rgba(0,0,0,0))',
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(4),
  },
}));

const PosterWidget = ({ widget, eager }: { widget: Widget<'poster'>; eager?: boolean }) => {
  const {
    configuration: { items },
    display_title,
  } = widget;
  const [{ image_path, navigation_configuration, title, description }] = items;
  const imgUrl = useResponsiveUrl({ url: image_path, desktop: 1920, mobile: 880 });
  const showItemInfo = navigation_configuration?.navigation_type !== 'content' && !!(title || description);

  return (
    <Banner as={Link} href={getNavigationUrl(navigation_configuration, display_title, navigation_configuration.content_id)} block>
      <CardImage
        src={imgUrl}
        alt={title || display_title}
        loading={eager ? 'eager' : undefined}
        {...(eager ? ({ fetchpriority: 'high' } as any) : {})}
      />
      {showItemInfo && (
        <PosterOverlay>
          {title && <Text variant="h3" weight="demibold">{title}</Text>}
          {description && <Text variant="body2" mt={1}>{description}</Text>}
        </PosterOverlay>
      )}
    </Banner>
  );
};

export default PosterWidget;
